exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___3rrxk .index-module__top___hUpF9{display:flex;flex-direction:column}.index-module__wrapper___3rrxk .index-module__top___hUpF9 .index-module__label___zDLEj{text-transform:uppercase;font-weight:500;letter-spacing:.5px;margin-bottom:.75em;font-size:15px}.index-module__wrapper___3rrxk .index-module__top___hUpF9 h1{font-size:32px;font-weight:600;margin-bottom:.5rem}.index-module__wrapper___3rrxk .index-module__top___hUpF9 p{font-size:21px;font-weight:500;color:#1e265c;margin-bottom:1rem}.index-module__wrapper___3rrxk img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;border-radius:5px;margin-bottom:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___3rrxk",
	"top": "index-module__top___hUpF9",
	"label": "index-module__label___zDLEj"
};